import * as R from 'ramda';

const config = {
  myProfile: {
    mailTo: 'inquiry.hk@athenabest.com',
  },
};

const codeMapping = scope => {
  const map = {
    plan_record_type: {
      IL: 'ILAS',
      IN: 'Insurance Plan',
      IR: 'Rider',
      FD: 'Investment',
      MPF: 'MPF',
      GI: 'General Insurance',
      PB: 'Private Bank',
      TU: 'Trust',
    },
    plan_record_type_color: {
      IL: '#619DA5',
      IN: '#005A97',
      IR: '#779D94',
      FD: '#998364',
      MPF: '#245A80',
      GI: '#8F7C77',
      PB: '#A07748',
      TU: '#5A895C',
    },
  };

  return R.propOr({}, scope, map);
};

const selectionValues = {
  applicants: [1, 2, 3, 4, 5],
  yes_no: [1, 0],
  product_action: ['NB', 'PI', 'TI', 'AM'],
  product_provider: [
    'AIA',
    'Blue',
    'AXA',
    'Chubb',
    'FPI',
    'FWD',
    'Generali',
    'Zurich',
    'Manulife',
    'MassMutual',
    'MetLife',
    'Prudential',
    'Tranamerica',
    'iFast',
    'BoC Life',
    'China Life',
    'CTF Life',
    'Hengansl',
    'Sun Life',
    'RL 360',
  ],
  product_type: ['IL', 'LI'],
};

const baseProductList = {
  AIA: ['IL', 'LI'],
  Blue: ['IL'],
  AXA: ['IL'],
  Chubb: ['LI'],
  FPI: ['IL', 'LI'],
  FWD: ['IL', 'LI'],
  'CTF Life': ['IL', 'LI'],
  Hengansl: ['IL'],
  'Sun Life HK': ['LI'],
  'RL 360': ['IL'],
};
// OAA contract/application, simplified
const productList = {
  NB: baseProductList,
  PI: baseProductList,
  TI: {
    'RL 360': ['IL'],
    Hengansl: ['IL'],
    FPI: ['LI'],
  },
  AM: baseProductList,
};

// const vendorB4login = `${vendorServer}/`;
// const vendorB2cCss = `${vendorServer}/b2c/assets/css`;
const appHost = process.env.REACT_APP_HOST;
const appBaseName = process.env.REACT_APP_BASENAME;
const vendorApiServer = process.env.REACT_APP_API_VENDOR;
const vendorApiToken = process.env.REACT_APP_VENDOR_API_TOKEN;
const vendorServer = process.env.REACT_APP_VENDOR_SERVER;

const cmsSetting = {
  form: {
    changeContactDetails: process.env.REACT_APP_FORM_CHANGE_OF_CONTACT_DETAILS,
  },
  inquiry: {
    email: 'inquiry.hk@athenabest.com',
    jaEmail: 'service.jp@athenabest.com',
  },
};

const avenueB2bLink = process.env.REACT_APP_AVENUE_B2B_LINK;

export {
  config,
  codeMapping,
  selectionValues,
  productList,
  appHost,
  appBaseName,
  vendorApiServer,
  vendorApiToken,
  vendorServer,
  cmsSetting,
  avenueB2bLink,
};
